import { FormPickerDatas } from '../local-types';
import ObjectUtils from './objectUtils';

export default class FormUtils {
    static nextState(event: any, state: any) {
        const {
            target: { name: key, type, value: val },
        } = event;
        let value = type === 'number' ? (val === '' ? null : Number(val)) : val;
        if (type === 'checkbox') {
            value = !ObjectUtils.getSubValueFromKey(state, key);
        }
        if (type === 'tel') {
            value = val.replace(/[^0-9+\s]/g, '');
        }
        const nextState = ObjectUtils.deepCopy(state);
        ObjectUtils.setSubValueFromKey(nextState, key, value);
        return nextState;
    }

    static nextSubState(event: any, state: any, subKey?: any) {
        if (subKey) {
            return {
                [subKey]: {
                    ...state[subKey],
                    ...FormUtils.nextState(event, state[subKey]),
                },
            };
        } else {
            return FormUtils.nextState(event, state);
        }
    }

    static getFields(form: any): any {
        if (!form) {
            return {};
        }

        return Array.prototype.slice
            .call(form)
            .filter((el) => el.name)
            .reduce((form, el) => {
                const value = el.value;

                return {
                    ...form,
                    [el.name]: value,
                };
            }, {});
    }

    static generateLangOptions(t): FormPickerDatas[] {
        const langOptions: FormPickerDatas[] = [
            {
                id: 'fr',
                name: t('lang.fr'),
            },
            {
                id: 'en',
                name: t('lang.en'),
            },
        ];
        return langOptions;
    }
}
